import RoomService from "../services/RoomService";
import {
  ONGOING_CONF_SORT_BY_NAME, ONGOING_CONF_SORT_BY_MIC, ONGOING_CONF_SORT_BY_VIDEO, ONGOING_CONF_SORT_BY_SIGNAL, ONGOING_CONF_SORT_BY_AUDIO_IN, ONGOING_CONF_SORT_BY_AUDIO_OUT, ONGOING_CONF_SORT_BY_VIDEO_IN, ONGOING_CONF_SORT_BY_VIDEO_OUT,ONGOING_CONF_SORT_BY_AUDIO_ENDPOINT, ONGOING_CONF_SORT_BY_AUDIO_BLOCK, ONGOING_CONF_SORT_BY_VOLUME, ONGOING_CONF_SORT_BY_LISTEN_VOLUME, ONGOING_CONF_SORT_BY_SPEAKER, ONGOING_CONF_SORT_BY_LECTURER, ONGOING_CONF_SORT_BY_EXCLUSIVE_CONTENT, ONGOING_CONF_SORT_BY_SHARE_CONTENT, ONGOING_CONF_SORT_BY_HANDUP,ONGOING_CONF_SORT_BY_ORDER, ONGOING_CONF_SORT_BY_CONTENT_IN, ONGOING_CONF_SORT_BY_CONTENT_OUT, ONGOING_CONF_SORT_BY_CONNECTION_STATUS
} from '../config'
import Utils from '../components/shared/Utils'

export default {
  namespaced: true,
  state: {
    roomList: null,
    conferenceId: null,
    roomId: localStorage.getItem("roomId") || null,
    jointParticipants: [],
    jointParticipantPackageList: [],
    addressBooks: null,
    conferenceHistory: null,
    conferenceIdentityList: JSON.parse(localStorage.getItem("conferenceList"))||[],
    notExistedconferenceIdentityList: null,
    bookedRoomList: [],
    sortPartySetting: null
  },
  mutations: {
    saveRoomList (state, roomList) {
      state.roomList = [...roomList].map(room => {
        const newRoom = { ...room };

        for (const key of Object.keys(newRoom)) {
          newRoom[key] = newRoom[key][0];
        }
        return newRoom;
      });

      if (state.roomList[0]) {
        localStorage.roomId = state.roomList[0].roomIdentifier;
      }
    },
    savePassCode (state, roomInfo) {
      const index = state.roomList.findIndex(
        room => room.roomIdentifier === roomInfo.room.id
      );
      state.roomList[index].passCode = roomInfo.room.passCode;
    },
    saveConferenceId (state, { conferenceId = null, roomId }) {
      state.roomId = roomId;
      state.conferenceId = conferenceId;
    },
    saveJointParticipants (state, { conferenceId, participants = null, partyName = null }) {
      if(!participants.length) return;
      const newPartyList = [...participants]
      const newParties = newPartyList.map(party => {
        return {...party, shareContentStatus: false}
      })
      state.jointParticipants = [...newParties]
      if(!state.sortPartySetting) {
        state.jointParticipants = newParties.sort((user1, user2) => {
          return user1.name < user2.name ? -1 : 1;
        });
      }
      if(partyName) {
        state.jointParticipants = [...state.jointParticipants.map(party => {
          let newParticipant = { ...party};
          if(newParticipant.name === partyName) {
            newParticipant.shareContentStatus = true
          }
          return newParticipant
        })];
      }

      // get set local party layout

      const partyLayoutContentList = JSON.parse(localStorage.getItem('partyLayoutJointParticipants'))

      const hasPartyLayoutContentList = () => {
        if(partyLayoutContentList) {
          if(conferenceId !== partyLayoutContentList.conferenceId) {
            localStorage.removeItem('partyLayoutJointParticipants')
            return false
          }
          return true
        }
        return false
      }
      // remove left participant in localstorage
      if(state.jointParticipants.length) {
        if(hasPartyLayoutContentList()) {
          const newParticipants = partyLayoutContentList.participants.filter(party => {
            return state.jointParticipants.some(mem => mem.endpointName === party.endpointName)
          })
          const newPartyLayoutContentList = {
            ...partyLayoutContentList,
            participants: newParticipants
          }
          localStorage.setItem('partyLayoutJointParticipants', JSON.stringify(newPartyLayoutContentList))
        }
      } else {
        localStorage.removeItem('partyLayoutJointParticipants')
      }
    },
    reloadLocalParticipants (state, status) {
      const newjointParticipants = [...state.jointParticipants].map(
        participant => {
          participant.audioMute = status;
          return participant;
        }
      );
      state.jointParticipants = [...newjointParticipants];
    },
    updateParticipant (state, participant) {
      state.jointParticipants = [...state.jointParticipants.map((party) => {
        if(party.id === participant.id) {
          party.audioMute = participant.audioMute
          party.videoMute = participant.videoMute
        }
        return party
      })];
    },
    removeParticipant (state, participant) {
      state.jointParticipants = [...state.jointParticipants].filter(
        item => item.id !== participant.id
      );
    },
    saveAddressBook (state, addressBooks) {
      state.addressBooks = addressBooks;
    },
    saveConferenceIdList(state, data) {
      state.conferenceIdentityList = [...data.map((conference, index) => {
        const newConf = conference
        newConf.id = index
        return newConf
      }) || []]
    },
    updateConferenceIdByRoom(state, data) {
      const isAdded = state.conferenceIdentityList.find(meeting => {
        return meeting.roomId === data.roomId
      })
      state.conferenceIdentityList = isAdded ? [...state.conferenceIdentityList.map((meeting, index) => {
        const newConf = meeting
        if(newConf.roomId === data.roomId) {
          newConf.conferenceId = data.conferenceId
        }
        newConf.displayName = `room ${index+1}`
        return newConf
      })] : [...state.conferenceIdentityList, {...data, displayName: `room ${state.conferenceIdentityList.length+1}`}]
    },
    setShareContentParticipants(state, data) {
      state.jointParticipants = [...data]
    },
    saveBookedRooms(state, data) {
      state.bookedRoomList = data
    },
    sortData(state, data) {
      state.sortPartySetting = {...data}
      let type = ''
      if(data.type === ONGOING_CONF_SORT_BY_NAME) {
        type = 'name';
      }
      if(data.type === ONGOING_CONF_SORT_BY_MIC) {
        type = "audioMute"
      }
      if(data.type === ONGOING_CONF_SORT_BY_VIDEO) {
        type = "videoMute"
      }
      if(data.type === ONGOING_CONF_SORT_BY_SIGNAL) {
        type = "signalingProtocol"
      }
      if(data.type === ONGOING_CONF_SORT_BY_AUDIO_IN) {
        type = "audio_in.fractionLossPeak"
      }
      if(data.type === ONGOING_CONF_SORT_BY_AUDIO_OUT) {
        type = "audio_out.fractionLossPeak"
      }
      if(data.type === ONGOING_CONF_SORT_BY_VIDEO_IN) {
        type = "video_in.fractionLossPeak"
      }
      if(data.type === ONGOING_CONF_SORT_BY_VIDEO_OUT) {
        type = "video_out.fractionLossPeak"
      }
      if(data.type === ONGOING_CONF_SORT_BY_AUDIO_ENDPOINT) {
        type = ONGOING_CONF_SORT_BY_AUDIO_ENDPOINT
      }
      if(data.type === ONGOING_CONF_SORT_BY_AUDIO_BLOCK) {
        type = ONGOING_CONF_SORT_BY_AUDIO_BLOCK
      }
      if(data.type === ONGOING_CONF_SORT_BY_VOLUME) {
        type = ONGOING_CONF_SORT_BY_VOLUME
      }
      if(data.type === ONGOING_CONF_SORT_BY_LISTEN_VOLUME) {
        type = ONGOING_CONF_SORT_BY_LISTEN_VOLUME
      }
      if(data.type === ONGOING_CONF_SORT_BY_SPEAKER) {
        type = ONGOING_CONF_SORT_BY_SPEAKER
      }
      if(data.type === ONGOING_CONF_SORT_BY_LECTURER) {
        type = ONGOING_CONF_SORT_BY_LECTURER
      }
      if(data.type === ONGOING_CONF_SORT_BY_EXCLUSIVE_CONTENT) {
        type = ONGOING_CONF_SORT_BY_EXCLUSIVE_CONTENT
      }
      if(data.type === ONGOING_CONF_SORT_BY_SHARE_CONTENT) {
        type = ONGOING_CONF_SORT_BY_SHARE_CONTENT
      }
      if(data.type === ONGOING_CONF_SORT_BY_HANDUP) {
        type = ONGOING_CONF_SORT_BY_HANDUP
      }
      if(data.type === ONGOING_CONF_SORT_BY_ORDER) {
        type = ONGOING_CONF_SORT_BY_ORDER
      }
      if(data.type === ONGOING_CONF_SORT_BY_CONTENT_IN) {
        type = "content_in.fractionLossPeak"
      }
      if(data.type === ONGOING_CONF_SORT_BY_CONTENT_OUT) {
        type = "content_out.fractionLossPeak"
      }
      if(data.type === ONGOING_CONF_SORT_BY_CONNECTION_STATUS) {
        type = ONGOING_CONF_SORT_BY_CONNECTION_STATUS
      }
      const props = type.split('.')
      if(data.value === 'asc') {
        state.jointParticipants = [...state.jointParticipants.sort((party1, party2) => {
          const party1Val = props.reduce((acc, prop) => {
            acc = acc[prop]
            return acc
          }, party1)
          const party2Val = props.reduce((acc, prop) => {
            acc = acc[prop]
            return acc
          }, party2)
          return String(party1Val).localeCompare(String(party2Val), 'en', {numeric: true})
        }).map((party, index) => {
          return {
            ...party,
            index: index+1,
          }
        })]
      } else {
        state.jointParticipants = [...state.jointParticipants.sort((party1, party2) => {
          const party1Val = props.reduce((acc, prop) => {
            acc = acc[prop]
            return acc
          }, party1)
          const party2Val = props.reduce((acc, prop) => {
            acc = acc[prop]
            return acc
          }, party2)
          return String(party2Val).localeCompare(String(party1Val), 'en', {numeric: true})
        }).map((party, index) => {
          return {
            ...party,
            index: index+1,
          }
        })]
      }
    },
    saveJointParticipantsMCU (state, { conferenceId, participants = null, realtimeHandup }) {
      const newPartyList = [...participants]
      const newParties = newPartyList.map((party) => {
        const newParticipant = realtimeHandup&&realtimeHandup.find(data => {
          return party.name&&party.name.includes(data.firstName);
        });
        const newParty = { ...party };
        newParty.isHandup = newParticipant ? newParticipant.isHandup : false;
        return {...newParty}
      })
      state.jointParticipants = [...newParties]

      if(!state.sortPartySetting) {
        state.jointParticipants = newParties.sort((user1, user2) => {
          return user1.name&&user2.name&&Utils.latinify(user1.name).localeCompare(Utils.latinify(user2.name), 'en');
        })
      }

      state.jointParticipants = state.jointParticipants.map((party, index) => {
        return {
          index: index+1,
          ...party
        }
      })

      // get set local party layout
      const partyLayoutContentList = JSON.parse(localStorage.getItem('partyLayoutJointParticipants'))

      const hasPartyLayoutContentList = () => {
        if(partyLayoutContentList) {
          if(conferenceId !== partyLayoutContentList.conferenceId) {
            localStorage.removeItem('partyLayoutJointParticipants')
            return false
          }
          return true
        }
        return false
      }
      // remove left participant in localstorage
      if(state.jointParticipants.length) {
        if(hasPartyLayoutContentList()) {
          const newParticipants = partyLayoutContentList.participants.filter(party => {
            return state.jointParticipants.some(mem => mem.endpointName === party.endpointName)
          })
          const newPartyLayoutContentList = {
            ...partyLayoutContentList,
            participants: newParticipants
          }
          localStorage.setItem('partyLayoutJointParticipants', JSON.stringify(newPartyLayoutContentList))
        }
      } else {
        localStorage.removeItem('partyLayoutJointParticipants')
      }
    },
    saveJointPartyInfo(state, data) {
      const index = state.jointParticipants.findIndex(party => party.id === data.partyId)
      state.jointParticipantPackageList[index] = { ...state.jointParticipants[index], ...data.info }
    },
    saveNotExistedConferenceIdList(state, data) {
      state.notExistedconferenceIdentityList = data
    }
  },
  actions: {
    getRooms ({ rootState, commit }, username) {
      return RoomService.getRooms(
        { owner: username },
        rootState.auth.token
      ).then(res => {
        if (res.data.status) {
          commit("saveRoomList", res.data.rooms);
        }
        return res;
      });
    },
    newPasscode ({ rootState, dispatch }, roomInfo) {
      return RoomService.newPasscode(roomInfo, rootState.auth.token).then(
        res => {
          if (res.data.status) {
            dispatch("getRooms", rootState.auth.username);
          }
          return res;
        }
      );
    },
    async deletePasscode ({ rootState, dispatch }, roomInfo) {
      return RoomService.deletePasscode(roomInfo, rootState.auth.token).then(
        res => {
          if (res.data.status) {
            dispatch("getRooms", rootState.auth.username);
          }
          return res;
        }
      );
    },
    async muteAll ({ rootState, commit }, data) {
      try {
        const { conferenceId } = data;
        if (conferenceId) {
          const res = await RoomService.muteAll(
            { conferenceId },
            rootState.auth.token
          );
          commit("reloadLocalParticipants", "true");
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    async unmuteAll ({ rootState, commit }, data) {
      try {
        const { conferenceId } = data;
        if (conferenceId) {
          const res = await RoomService.unmuteAll(
            { conferenceId },
            rootState.auth.token
          );
          commit("reloadLocalParticipants", "false");
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    async muteAudio ({ rootState, commit }, participant) {
      try {
        const { conferenceID, id, audioMute } = participant;
        const newAudioMute = audioMute === "true" ? "false" : "true";
        const newaudioControl =
          newAudioMute === "true" ? "mute-audio" : "unmute-audio";
        const newParticipant = {
          ...participant,
          audioMute: newAudioMute
        };

        if (conferenceID) {
          const res = await RoomService.participantControl(
            {
              conferenceId: conferenceID,
              participantId: id,
              control: newaudioControl
            },
            rootState.auth.token
            );
          commit("updateParticipant", newParticipant);
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    async muteVideo ({ rootState, commit }, participant) {
      try {
        const { conferenceID, id, videoMute } = participant;
        const newVideoMute = videoMute === "true" ? "false" : "true";
        const newVideoControl =
          newVideoMute === "true" ? "suspend-video" : "resume-video";
        const newParticipant = {
          ...participant,
          videoMute: newVideoMute
        };
        if (conferenceID) {
          const res = await RoomService.participantControl(
            {
              conferenceId: conferenceID,
              participantId: id,
              control: newVideoControl
            },
            rootState.auth.token
            );
          commit("updateParticipant", newParticipant);
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    async deleteParticipant ({ rootState, commit }, participant) {
      try {
        const { conferenceID, id } = participant;
        if (conferenceID) {
          const res = await RoomService.participantControl(
            {
              conferenceId: conferenceID,
              participantId: id,
              control: "disconnect"
            },
            rootState.auth.token
          );
          if (res.data.status) {
            commit("removeParticipant", participant);
          }
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    async deletePartyMCU({rootState}, data) {
      try {
        const { roomID_MCU, host_MCU, partyId } = data
        const result = RoomService.deletePartyMCU({
          owner: rootState.auth.username,
          roomID_MCU,
          host_MCU,
          partyId
        },rootState.auth.token)
        return result
      } catch(err) {
        throw Error(err)
      }
    },
    async setDialOut ({ rootState }, dialOutInfo) {
      const newDialogInfo = { ...dialOutInfo };
      try {
        const res = await RoomService.dialOut(
          newDialogInfo,
          rootState.auth.token
        );
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async setLayout ({ rootState }, data) {
      const layoutInfo = { ...data };
      try {
        const res = await RoomService.setLayout(
          layoutInfo,
          rootState.auth.token
        );
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async setLecturer ({ rootState }, data) {
      const lecturerInfo = { ...data };
      try {
        const res = await RoomService.setLecturer(
          lecturerInfo,
          rootState.auth.token
        );
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async getAddressBook ({ rootState, commit }) {
      const { username } = rootState.auth;
      try {
        const res = await RoomService.fetchAddressBook(
          { username },
          rootState.auth.token
        );
        if (res) {
          commit("saveAddressBook", res.data.data);
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async createAddressBook ({ rootState, dispatch }, addressbook) {
      const newAddressBook = {
        username: rootState.auth.username,
        addressbook
      };
      try {
        const res = await RoomService.createAddressBook(
          newAddressBook,
          rootState.auth.token
        );
        dispatch("getAddressBook");
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async deleteAddressBook ({ rootState, dispatch }, addressBookId) {
      try {
        const res = await RoomService.deleteAddressBook(
          { id: addressBookId },
          rootState.auth.token
        );
        dispatch("getAddressBook");
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async startConference ({ rootState, dispatch }, roomIdentifier) {
      try {
        const res = await RoomService.startConference(
          { room: roomIdentifier },
          rootState.auth.token
        );
        if (res.data.status) {
          return await dispatch("getConferenceIdByAddressBook", roomIdentifier);
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async getConferenceIdByAddressBook ({ rootState, commit }, roomId) {
      try {
        const owner = rootState.auth.username
        const res = await RoomService.getConferenceID(
          { owner, roomId },
          rootState.auth.token
        );
        if (res.data.status) {
          commit("saveConferenceId", {
            conferenceId: res.data.conferenceId,
            roomId
          });
          commit('updateConferenceIdByRoom', {
            conferenceId: res.data.conferenceId,
            roomId
          })
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async lockConference ({ rootState }, data) {
      try {
        const { conferenceId } = data;
        if (conferenceId) {
          const res = await RoomService.lockConference(
            { conferenceId, control: 'lock-conference' },
            rootState.auth.token
          )
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    async unLockConference ({ rootState }, data) {
      try {
        const { conferenceId } = data;
        if (conferenceId) {
          const res = await RoomService.lockConference(
            { conferenceId, control: 'unlock-conference' },
            rootState.auth.token
          )
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    getConferenceIdList({rootState, commit}, data) {
      return RoomService.getConferenceIDList({
        owner: rootState.auth.username,
        ...data
      }, rootState.auth.token).
      then(dataRes => {
        Promise.all(dataRes.data.conferences.map((conf) => {
          return RoomService.
          getMCURoom({
            owner: rootState.auth.username,
            conferenceId: conf.conferenceId,
            roomId: conf.roomId
          }, rootState.auth.token).
          then((result) => {
            if(result.data&&result.data.status) {
              return {
                conferenceId: conf.conferenceId,
                displayName: result.data.message.displayName,
                host_MCU: result.data.message.host_MCU,
                isExisted: true,
                roomId: conf.roomId,
                roomID_MCU: result.data.message.roomID_MCU,
              }
            } else {
              return {
                conferenceId: conf.conferenceId,
                isExisted: false,
                roomId: conf.roomId,
              }
            }
          })
        })).
        then(data => {
          const roomList = data.filter(room => {
            return room.isExisted && (room.displayName || room.roomID_MCU)
          })
          const notExistedRoomList = data.filter(room => {
            return !room.isExisted
          })
          commit('saveConferenceIdList', roomList)
          commit('saveNotExistedConferenceIdList', notExistedRoomList)
          localStorage.setItem('conferenceList', JSON.stringify(roomList))
        })
        return dataRes
      })
    },
    getJointParticipantsByConfId ({ rootState, commit, state }, data) {
      const { conferenceId, roomId } = data;
      const owner = rootState.auth.username;
      if (conferenceId && roomId) {
        // get share content status of username first then get party list
        // return dispatch('getPartyShareContentStatus', { conferenceId, roomId }).then(resData => {
        //   if(resData.status) {
            return RoomService.getJointParticipants(
              { owner, conferenceId, roomId },
              rootState.auth.token
            ).then(res => {
              if (res.data.status) {
                commit("saveJointParticipants", {conferenceId, participants: res.data.participants, partyName: '' });
                if(state.sortPartySetting) {
                  commit("sortData", state.sortPartySetting)
                }
              }
              return res
            })
        //   }
        //   return resData
        // })
      }
    },
    async resetDefaultLayout({ rootState }, data) {
      try {
        const { roomID_MCU, host_MCU } = data;
        if (roomID_MCU) {
          const res = await RoomService.resetDefaultLayout(
            { roomID_MCU, host_MCU , username: rootState.auth.username},
            rootState.auth.token
          )
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    setShareContentParticipant({rootState, commit}, data) {
      try {
        const {party: {id}, roomID_MCU, host_MCU} = data
        return RoomService.setShareContent({
          roomID_MCU,
          username: rootState.auth.username,
          partyID: id,
          host_MCU
        }, rootState.auth.token).then((res) => {
          commit('setShareContentParticipants', data.list)
          return res
        })
      } catch(err) {
        throw new Error(err);
      }
    },
    resetShareContentByParticipant({rootState, commit}, data) {
      try {
        const { conferenceId, roomID_MCU, host_MCU } = data;
        return RoomService.resetShareContentParty({
          conferenceId,
          roomID_MCU,
          host_MCU,
          username: rootState.auth.username
        }, rootState.auth.token).then((res) => {
          commit('setShareContentParticipants', data.list)
          return res
        })
      } catch(err) {
        throw new Error(err);
      }
    },
    setPartyLayout({rootState}, data) {
      const { roomID_MCU, party: {id}, host_MCU, layout} = data;
      return RoomService.setParticipantForcedLayout({
        roomID_MCU,
        layout,
        username: rootState.auth.username,
        partyId: id,
        host_MCU
      }, rootState.auth.token).then((res) => {
        return res
      })
    },
    resetPartyLayout({rootState}, data) {
      const { roomID_MCU, party: {id}, host_MCU } = data;
      return RoomService.resetParticipantForcedLayout({
        roomID_MCU,
        host_MCU,
        username: rootState.auth.username,
        partyId: id
      }, rootState.auth.token).then((res) => {
        return res
      })
    },
    randomPasscode ({ rootState, dispatch }, roomInfo) {
      return RoomService.randomPasscode(roomInfo, rootState.auth.token).then(
        res => {
          if (res.data.status) {
            dispatch("getRooms", rootState.auth.username);
          }
          return res;
        }
      );
    },
    sendPassCode({rootState}, data) {
      return RoomService.sendPassCode(data, rootState.auth.token).then(
        res => {
          return res;
        }
      );
    },
    getBookedRooms({rootState, commit}) {
      return RoomService.getBookedRooms({username: rootState.auth.username}, rootState.auth.token).then(res => {
        if(res.data.status) {
          commit('saveBookedRooms', res.data.data)
        }
        return res;
      });
    },
    removeBookedRooms({rootState, dispatch}, data) {
      return RoomService.removeBookedRooms({username: rootState.auth.username, ...data}, rootState.auth.token).then(res => {
        return dispatch('getBookedRooms').then(() => {
          return res
        })
      })
    },
    disconnectAllParty({rootState, commit}, data) {
      return RoomService.disconnectAllParty(
        { ...data },
        rootState.auth.token
      ).then(res => {
        if (res.data.status) {
          commit("saveJointParticipants", {conferenceId: data.conferenceId, participants: []});
        }
        return res
      })
    },
    changeDisplayNameParty({rootState, dispatch}, data) {
      return RoomService.updatePartyDisplayName(data, rootState.auth.token).then((result) => {
        if(result.status) {
          dispatch('getJointParticipantsByConfId', {roomId: data.roomId, conferenceId: data.conferenceId, owner: data.owner})
        }
        return result
      })
    },
    getPartyShareContentStatus({rootState}, data) {
      return RoomService.getPartyShareContentStatus({...data, username: rootState.auth.username}, rootState.auth.token)
    },
    getConfPartyByMCU({rootState, commit, dispatch,state, rootGetters}, data) {
      const { roomID_MCU, host_MCU, conferenceId, realtimeHandup } = data;
      const owner = rootState.auth.username;
      if(!rootGetters['auth/isLoggedIn']) {
        dispatch('auth/logOut')
      }
      if (roomID_MCU && host_MCU && conferenceId) {
        return RoomService.getConfPartyByMCU(
          { owner, roomID_MCU, host_MCU },
          rootState.auth.token
        ).then(res => {
          if (res.data.status) {
            commit("saveJointParticipantsMCU", { conferenceId, participants: res.data.participants, partyName: '', realtimeHandup });
            if(state.sortPartySetting) {
              commit("sortData", state.sortPartySetting)
            }
          } else {
            commit("saveJointParticipantsMCU", {conferenceId, participants: [], partyName: '', realtimeHandup });
          }
          return res
        })
      }
    },
    getPartyInfoByMCU({ rootState, commit }, data) {
      const { roomID_MCU, host_MCU, partyId } = data;
      const owner = rootState.auth.username;
      return RoomService.getPartyInfoByMCU({ owner, roomID_MCU, host_MCU, partyId }, rootState.auth.token).then(result => {
        commit('saveJointPartyInfo', { partyId, info: result.data.party })
      })
    },
    async muteAudioMCU ({ rootState }, participant) {
      try {
        const { roomID_MCU, host_MCU, id, audioMute, videoMute } = participant;
        const newAudioMute = audioMute === "true" ? "false" : "true";
        const newaudioControl =
          newAudioMute === "true" ? "mute-audio" : "unmute-audio";

        if (roomID_MCU) {
          const res = await RoomService
          .setConfPartyControlByMCU({
            owner: rootState.auth.username,
            participantId: id,
            control: newaudioControl,
            roomID_MCU,
            host_MCU,
            otherControl: videoMute
          }, rootState.auth.token);
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    async muteVideoMCU ({ rootState }, participant) {
      try {
        const { roomID_MCU, host_MCU, id, audioMute, videoMute } = participant;
        const newVideoMute = videoMute === "true" ? "false" : "true";
        const newVideoControl =
          newVideoMute === "true" ? "suspend-video" : "resume-video";
        if (roomID_MCU) {
          const res = await RoomService
          .setConfPartyControlByMCU({
            owner: rootState.auth.username,
            participantId: id,
            control: newVideoControl,
            roomID_MCU,
            host_MCU,
            otherControl: audioMute
          }, rootState.auth.token);
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    async muteAllMCU({ rootState, state }, data) {
      try {
        const { roomID_MCU, host_MCU } = data;
        const isAllAudioMute = state.jointParticipants.every(party => {
          return party.audioMute === "true"
        });
        const newAudioControl =
        isAllAudioMute === true ? "unmute-all" : "mute-all";
        if (roomID_MCU) {
          const res = await RoomService
          .setConfAllPartyControlByMCU({
            owner: rootState.auth.username,
            control: newAudioControl,
            roomID_MCU,
            host_MCU
          }, rootState.auth.token);
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    async disconnectPartyMCU({ rootState }, participant) {
      try {
        const { roomID_MCU, host_MCU, id } = participant;
        if (roomID_MCU) {
          const res = await RoomService
          .setConfPartyControlByMCU({
            owner: rootState.auth.username,
            participantId: id,
            control: "disconnect",
            roomID_MCU,
            host_MCU
          }, rootState.auth.token);
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    async setLayoutConfMCU ({ rootState }, data) {
      try {
        const { roomID_MCU, host_MCU, layout } = data;
        if (roomID_MCU) {
          const res = await RoomService
          .setLayoutConfByMCU({
            owner: rootState.auth.username,
            layout,
            roomID_MCU,
            host_MCU
          }, rootState.auth.token);
          return res;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    exportConferenceInfo({rootState}, data) {
      return RoomService.exportConferenceInfo({conferenceId: data, owner: rootState.auth.username}, rootState.auth.token)
    },
    getPartyPacket({rootState}, data) {
      const { conferenceId, roomId, name } = data;
      return RoomService.getPartyPacketInfo({
        conferenceId,
        roomId,
        username: rootState.auth.username,
        participantName: name
      }, rootState.auth.token).then((res) => {
        
        return res
      })
    },
    async setLecturerMCU ({ rootState }, data) {
      const lecturerInfo = { ...data, owner: rootState.auth.username };
      try {
        const res = await RoomService.setLecturerMCU(
          lecturerInfo,
          rootState.auth.token
        );
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    disconnectAllPartyMCU({rootState, commit}, data) {
      return RoomService.disconnectAllPartyMCU(
        { ...data },
        rootState.auth.token
      ).then(res => {
        if (res.data.status) {
          commit("saveJointParticipants", {conferenceId: data.conferenceId, participants: []});
        }
        return res
      })
    },
    changeDisplayNamePartyMCU({rootState}, data) {
      return RoomService.updatePartyDisplayNameMCU(data, rootState.auth.token).then((result) => {
        return result
      })
    },
    async updateConferencePasswordMCU({rootState}, data) {
      try {
        const { roomID_MCU, host_MCU, confPassword } = data;

        const result = RoomService.updateConferencePassMCU({
          owner: rootState.auth.username,
          roomID_MCU,
          host_MCU,
          confPassword
        },rootState.auth.token)

        return result
      } catch(err) {
        throw Error(err)
      }
    },
    async updateBlockAudioMCU({rootState}, data) {
      try {
        const { roomID_MCU, host_MCU, partyId, audioBlockStatus } = data;

        const result = RoomService.updateBlockAudioMCU({
          owner: rootState.auth.username,
          roomID_MCU,
          host_MCU,
          partyId,
          audioBlockStatus
        },rootState.auth.token)

        return result
      } catch(err) {
        throw Error(err)
      }
    },
    async setVolumeMCU({rootState}, data) {
      try {
        const { roomID_MCU, host_MCU, partyId, volume } = data;

        const result = RoomService.setVolumeMCU({
          owner: rootState.auth.username,
          roomID_MCU,
          host_MCU,
          partyId,
          volume
        },rootState.auth.token)

        return result
      } catch(err) {
        throw Error(err)
      }
    },
    async setLayoutMCU({rootState}, data) {
      try {
        const { roomID_MCU, host_MCU, layout } = data;

        const result = RoomService.setLayoutMCU({
          owner: rootState.auth.username,
          roomID_MCU,
          host_MCU,
          layout
        },rootState.auth.token)

        return result
      } catch(err) {
        throw Error(err)
      }
    },
    async setAutoLayoutMCU({rootState}, data) {
      try {
        const { roomID_MCU, host_MCU } = data;

        const result = RoomService.setAutoLayoutMCU({
          owner: rootState.auth.username,
          roomID_MCU,
          host_MCU
        },rootState.auth.token)

        return result
      } catch(err) {
        throw Error(err)
      }
    },
    async getCurrentConferenceIdForAddText({rootState}, data) {

      try {
        const result = RoomService.getCurrentConferenceIdForAddText({
          owner: rootState.auth.username,
          conferenceId: data.conferenceId
        }, rootState.auth.token)

        return result
      } catch(err) {
        throw Error(err)
      }
    },
    async setCurrentConferenceIdForAddText({rootState}, data) {
      try {
        const { roomID_MCU, host_MCU, conferenceId, time } = data;
        const result = RoomService.setCurrentConferenceIdForAddText({
          owner: rootState.auth.username,
          conferenceId,
          roomID_MCU,
          host_MCU,
          time
        },rootState.auth.token)

        return result
      } catch(err) {
        throw Error(err)
      }
    },
    async setListenVolumeMCU({rootState}, data) {
      try {
        const { roomID_MCU, host_MCU, partyId, volume } = data;

        const result = RoomService.setListenVolumeMCU({
          owner: rootState.auth.username,
          roomID_MCU,
          host_MCU,
          partyId,
          volume
        },rootState.auth.token)

        return result
      } catch(err) {
        throw Error(err)
      }
    },
    async setDialOutByIPID({rootState}, data) {
      try {
        const { roomID_MCU, host_MCU, party } = data;

        const result = RoomService.dialOutByIPID({
          owner: rootState.auth.username,
          roomID_MCU,
          host_MCU,
          party
        },rootState.auth.token)

        return result
      } catch(err) {
        throw Error(err)
      }
    }
  }
};
